// Enums & Fields
import RouteUrls from '@/app/root/enums/RouteUrls';
import POS_TERMINALS_TABS from '@/app/root/enums/tabs/PosTerminalsTabs';
import SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS from '@/app/root/enums/tabs/SubscriptionAndTerminalDetailsTabs';
import eventLogFields from '@/app/modules/terminals/fields/eventLogFields';
import searchContractFields from '../../../fields/searchContractFields';
// Components
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderApplication from '@/app/modules/contracts/components/application/RenderApplication';
import RenderBankCode from '@/app/modules/contracts/components/bankCode/RenderBankCode';
import RenderSimOperator from '@/app/modules/sims/components/simOperator/RenderSimOperator';
import DropdownSearchContractActionsRow from '../../dropdown/DropdownSearchContractActionsRow';
// Common Utils
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import getIccidWithoutPrefix from '@/common-utils/functions/getIccidWithoutPrefix';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import Permissions from '@/app/permissions/Permissions';

export const columnsSearchContractsId = 'searchContracts';

export const columnsSearchContracts = (headerPackage) => {

    return ([
        generateColumnDefByField({
            field: searchContractFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => {
                return (
                    <DetailsButton
                        pathParams={{ subscriptionId: row.original.posTerminalSubscription }}
                        baseUrl={RouteUrls.SUBSCRIPTION_DETAILS.url}
                        urlParams={{
                            view: POS_TERMINALS_TABS.DEFAULT.name,
                            viewDetails: SUBSCRIPTION_AND_TERMINAL_DETAILS_TABS.CONNECTIONS.name,
                            filters: [
                                {
                                    key: eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.ACCEPTANCE_AGREEMENT_NUMBER.key,
                                    value: row.original.number
                                },
                                {
                                    key: eventLogFields.FINANCIAL_INFORMATION.ACCEPTANCE_SYSTEM_INFORMATION.APPLICATION_ID.key,
                                    value: row.original.itp
                                }
                            ]
                        }}
                        requiredPermissions={[
                            Permissions.POS_TERMINAL_READ.name,
                            Permissions.POS_TERMINAL_LIST_EVENT_LOGS.name
                        ]}
                    />
                );
            },
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: searchContractFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return (
                    <DropdownSearchContractActionsRow
                        searchContract={cell.row.original}
                        setLaunchRefetch={headerPackage.setLaunchRefetch}
                    />
                );
            },
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: searchContractFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderApplication applicationCode={cell.getValue(searchContractFields.APPLICATION.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.LAST_REMOTE_COLLECTION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.LAST_REMOTE_COLLECTION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.POS_TERMINAL.MANUFACTURER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.MODEL,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.POS_TERMINAL.SERIAL_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.LEGAL_BUSINESS_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: searchContractFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: searchContractFields.NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.RANK,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(searchContractFields.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.X25_ADDRESS,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.ITP,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.CB_VERSION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell && cell.getValue(searchContractFields.CB_VERSION.key) &&
                <span>{cell.getValue(searchContractFields.CB_VERSION.key).replace(/^CB/, '')}</span>
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.LAST_ICCID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const simNumber = cell.getValue(searchContractFields.LAST_ICCID.key);
                const iccidOperators = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(searchContractFields.LAST_ICCID_OPERATOR));
                return (
                    simNumber &&
                    <div className='text-center flex'>
                        <div className='flex flex-col mr-1'>
                            <small className='whitespace-nowrap'>{getIccidWithoutPrefix(simNumber)}</small>
                            <RenderSimOperator iccidOperators={iccidOperators} />
                        </div>
                    </div>
                );
            }
        }),
        generateColumnDefByField({
            field: searchContractFields.SPECIFICATION,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.BULLETINS,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.ERT_CODE,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.CB_AGREEMENT_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.CB_AGREEMENT_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.CB_AGREEMENT_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.PCI_VERSION,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.PCI_EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.PCI_EXPIRATION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.PCI_PP_VERSION,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: searchContractFields.PCI_PP_EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.PCI_PP_EXPIRATION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.EXPIRATION_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.END_OF_DEPLOYMENT_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.END_OF_DEPLOYMENT_DATE.key)} />
            )
        }),
        generateColumnDefByField({
            field: searchContractFields.END_OF_USE_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(searchContractFields.END_OF_USE_DATE.key)} />
            )
        })
    ]).filter(col => !!col);
};